import createIcon from '../../createIcon';

/**
 * @component @name ArrowDropUp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAxNC41TDEyIDkuNUwxNyAxNC41SDdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ArrowDropUp = createIcon('ArrowDropUp', [
  ['path', { d: 'M7 14.5L12 9.5L17 14.5H7Z', key: '1l6j8n' }],
]);

export default ArrowDropUp;
